
export const options = [
	{
		label:"Afrikaans",
		value: "af"
	},
	{
		label:"Arabic",
		value: "am"
	},
	{
		label:"English",
		value: "en"
	},
	{
		label:"Chinese (Simplified)",
		value: "zh-CN"
	},
	{
		label:"English",
		value: "en"
	},
	{
		label:"French",
		value: "fr"
	},
	
	{
		label:"German",
		value: "de"
	},
	{
		label:"Italian",
		value: "ga"
	},
	
	{
		label:"Portuguese",
		value: "pt"
	},
	
	{
		label:"Spanish",
		value: "es"
	},
	{
		label:"Swahili",
		value: "sw"
	},
	{
		label:"Turkish",
		value: "tr"
	},
	{
		label:"Russian",
		value: "ru"
	},
	
];
	
